<template>
    <div class="invitation-list">
        <heading title="Sent Invitations"></heading>
        <data-table ref="dataTable"
                    :show-filters="true"
                    :show-pager="true"
                    :get-items="getEntries"
                    v-model="filters"
                    :fields="fields">
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key === 'email'">
                    {{ slotProps.row.item.email }}
                </div>
                <div v-if="slotProps.row.field.key === 'created'">
                    <timestamp :date="slotProps.row.item.created"/>
                </div>
                <div v-if="slotProps.row.field.key === 'role'">
                    <user-role-badge :role="slotProps.row.item.role"/>
                </div>
                <div v-if="slotProps.row.field.key === 'status'">
                    <b-badge :variant="statusBadgeVariant(slotProps.row.item.status)">
                        {{slotProps.row.item.status}}
                    </b-badge>
                </div>
                <div v-if="slotProps.row.field.key === 'user'">
                    <user-details :user="slotProps.row.item.user"/>
                </div>
                <div v-if="slotProps.row.field.key === 'actions'">
                    <b-button @click="resend(slotProps.row.item)"
                              v-if="slotProps.row.item.status === 'INCOMPLETE'">
                        Resend
                    </b-button>
                </div>
            </template>
        </data-table>
    </div>
</template>

<script>
import UserDetails from "@/components/UserDetails";

export default {
    name: "InvitationList",
    components: {UserDetails},
    data () {
        return {
            fields: [
                { key: 'email', sortable: true, label: 'Email' },
                { key: 'role', sortable: true, label: 'Role' },
                { key: 'created', sortable: true, label: 'Date' },
                { key: 'status', sortable: true, label: 'Account Status' },
                { key: 'user', sortable: true, label: 'Sent by' },
                { key: 'actions', sortable: true, label: 'Resend' },
            ],
            filters: {
                status: {
                    field: 'status',
                    label: 'Account Status',
                    type: 'select',
                    options: [
                        { value: 'COMPLETE', text: 'Complete' },
                        { value: 'INCOMPLETE', text: 'Incomplete', },
                    ]
                },
                after: { field: 'after', type: 'date', value: null, label: 'After' },
                before: { field: 'before', type: 'date', value: null, label: 'Before' },
            }
        }
    },
    methods: {
        getEntries(listParams) {
           return this.$api.getItems(this, 'invitation', this.filters, listParams)
        },
        statusBadgeVariant(status) {
            if(status === 'COMPLETE') {
                return 'success'
            } else if (status === 'INCOMPLETE') {
                return 'danger'
            }
        },
        resend(invite) {
            return this.$api.resendInvitation(this, invite).then((response) => {
                this.$toasted.success('Invite Sent');
            }, (error) => {
                this.$toasted.error('Error resending invite');
            })
        }
    }
}
</script>

<style scoped>

</style>